<template>
  <div>
    <div :id="mapId" class="map"></div>
    <div id="msg"></div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import './customRouteMapTemplate.scss';

export default defineComponent({
  name: 'CustomRouteMapTemplateComponent',
  components: {},
  props: {
    mapId: {
      type: String,
      default: 'map',
      required: false
    }
  },
  data() {
    return {}
  },


});
</script>

<style>
  .map {
    height: 630px;
    width: 100%;
    border-radius: 1.5rem;
  }
</style>
